<template>
  <div class="smart-stops" v-loading="isLoading">
    <sc-object-card-list
      v-if="Array.isArray(stopInfo) && stopInfo"
      :fields="stopInfo"
    />
    <r-text type="caption" v-else-if="stopInfo">
      <div>{{ $t(`no_dit`) }}</div>
      <div>{{ $t(`last_data_update`) }}</div>
      <div>{{ stopInfo }}</div>
    </r-text>
    <r-text type="caption" v-else>
      {{ $t(`no_info`) }}
    </r-text>
  </div>
</template>

<script>
import scObjectCardList from "./object-card-list";
import moment from "moment";

export default {
  components: {
    scObjectCardList
  },
  props: {
    id: {
      type: String,
      required: true,
      default: () => null
    }
  },
  data() {
    return {
      stopInfo: null,
      isLoading: false
    };
  },
  computed: {
    objectCard() {
      return this.$store.state.situationCenter.objectCard;
    }
  },
  watch: {
    id() {
      this.getStopInfo();
    }
  },
  methods: {
    getDateTime(val) {
      return moment(val)
        .utc()
        .format("DD.MM.YY HH:mm");
    },
    async getStopInfo() {
      this.isLoading = true;
      this.stopInfo = null;

      const publicStopId = this.objectCard.data.properties.id.split("id:")[1];

      if (publicStopId) {
        try {
          const { data } = await this.$store.dispatch("REQUEST", {
            url: `TagilPublicTransport?format=dit&stop_id=${publicStopId}`
          });
          if (Object.keys(data).length > 0) {
            if (data.route) {
              this.stopInfo = [
                {
                  type: "route_number",
                  value: data.route.short_name
                },
                {
                  type: "route_name",
                  value: data.route.long_name.slice(
                    data.route.short_name.length
                  )
                },
                {
                  type: "minutes_to_arrive",
                  value:
                    data.minutes_to_arrive === 0
                      ? "Прибывает"
                      : data.minutes_to_arrive
                }
              ];
            } else {
              this.stopInfo = this.getDateTime(data.time);
            }
          }
          this.isLoading = false;
        } catch (e) {
          this.isLoading = false;
          console.log(e);
        }
      }
    }
  },
  created() {
    this.getStopInfo();
  }
};
</script>

<style lang="scss"></style>

<i18n>
{
  "ru": {
    "no_dit": "Информационное табло не настроено",
    "no_info": "Информация отсутствует",
    "last_data_update": "Время последнего обновления данных:"
  },
  "en": {
    "no_dit": "Information display is not configured",
    "no_info": "No information available",
    "last_data_update": "ime of the last data update:"
  }
}
</i18n>
